<template>
  <div class="product-grid">
    <component
      :is="componentName(item)"
      v-for="(item, index) in items"
      :key="getId(item, index)"
      :item="item"
      :hover-card-enabled="hoverCardSetting"
    />
  </div>
</template>

<script>
import themeSettings from '../mixins/themeSettings'

export default {
  name: 'product-catalog-grid-view',
  mixins: [themeSettings],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  mounted: function() {
    this.$store.dispatch('products/currentStock')
  },
  methods: {
    componentName(item) {
      if (item.node_type) {
        // const defaultLayout = `${item.node_type.replace(/[_\s]/, '-')}-grid-item-0001`
        const defaultLayout = `wine-product-grid-item-0001`
        const themeChoiceAvailable = (this.themeSettings && this.themeSettings !== null && Object.keys(this.themeSettings).includes('products') && this.themeSettings.products['catalogue-grid'])

        return (themeChoiceAvailable) ? `${this.themeSettings.products['catalogue-grid']}` : defaultLayout
      }

      return 'generic-product-grid-item'
    },
    getId(item, index) {
      if (item.id != null) return item.id
      else if (item.nid != null) return item.nid
      else return index
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@scss/custom.scss';

.list-enter-active,
.list-leave-active {
  transition: all .8s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
.product-grid {
  display: grid;
  grid-gap: 1.5em;
  margin-bottom: 2.5em;
  width:100%;
  grid-template-columns: repeat(2, 1fr);

  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
